<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">تعديل مدينة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/citiesview">المدن</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">تعديل مدينة</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div v-if="loader" class="text-center">
          <mainLoader />
        </div>
        <div v-if="!loader" class="row justify-content-center align-content-center mb-4 mt-5">
          <div class="col-12 col-md-8">
            <h5 class="text-brown me-2">
              <i class="bi bi-pencil-square mx-2 text-brown"></i> تعديل مدينة
            </h5>
            <div class="card">
              <div class="text-center pt-3">
                <errorAlert v-if="cityError" :alertMessage= "message" />
              </div>
              <div v-if="successfuly" class="text-center pt-3">
                <successAlert :message="message" />
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <label for="">المنطقة</label>
                    <select class="form-select" v-model="region_id">
                      <option v-for="(row,index) in rows" :key="index" :value="row.id">
                        {{ row.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <form action="" @submit.prevent="cityUpdate">
                  <div class="row py-2">
                    <div class="col-12 col-sm-6">
                      <label for="">الاسم - عربي</label>
                      <input type="text" class="form-control" v-model="cityName">
                    </div>
                    <div class="col-12 col-sm-6">
                      <label for="">الاسم - انجليزي</label>
                      <input type="text" class="form-control" v-model="nameEn">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col-12 col-sm-6">
                      <label for="">خط العرض (latitude)</label>
                      <input type="number" class="form-control" v-model="latitude" step="0.000001">
                    </div>
                    <div class="col-12 col-sm-6">
                      <label for="">خط الطول (longitude)</label>
                      <input type="number" class="form-control" v-model="longitude" step="0.000001">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col-12 col-sm-6">
                      <label for="">الصورة - عربي</label>
                      <input type="file" class="form-control" 
                      @change="onFileAdd($event.target.files)">
                    </div>
                    <div class="col-12 col-sm-6">
                      <label for="">الصورة - انجليزي</label>
                      <input type="file" class="form-control" 
                      @change="onFileAddEn($event.target.files)">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col-12 col-sm-6">
                      <img v-if="coverimg" :src="BASE_URL+'uploads/'+coverimg" class="img-fluid" alt="">
                    </div>
                    <div class="col-12 col-sm-6">
                      <img v-if="coverEn" :src="BASE_URL+'uploads/'+coverEn" class="img-fluid" alt="">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col-12 col-sm-6">
                      <label for="">كود هيئة العقار:</label>
                      <input type="text" class="form-control" v-model="regaId" />
                    </div>
                    <div class="col-12 col-sm-6">
                      <label for="">الحاله</label>
                      <select class="form-control" v-model="status">
                        <option :value="true">نشط</option>
                        <option :value="false">غير نشط</option>
                      </select>
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col text-center">
                      <loader v-if="isLoading" />
                      <button v-else type="submit" class="btn btn-success">إرسال</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name:'citieupdate',
  data(){
    return {
      city_id: this.$route.params.id,
      loader: false,
      cityError: false,
      message: '',
      cityName: "",
      nameEn: "",
      longitude: "",
      latitude: "",
      isLoading: false,
      status: null,
      successfuly: false,
      rows: [],
      region_id: null,
      coverimg: "",
      coverEn: null,
      regaId: null,
    }
  },
  computed:{
    ...mapGetters(['BASE_URL'])
  },
  methods:{
    region_get_Data() {
      this.loader = true;
      this.$http.get(`/api/admin/cities/retrieve/${this.city_id}`).then(res => {
        this.loader = false;
        this.cityName = res.data.city.name;
        this.nameEn = res.data.city.nameEn;
        this.latitude = res.data.city.latitude;
        this.longitude = res.data.city.longitude;
        this.coverimg = res.data.city.cover;
        this.coverEn = res.data.city.coverEn;
        this.status = res.data.city.isActive;
        this.region_id = res.data.city.regionId;
        this.regaId = res.data.city.regaId;
        this.rows = res.data.regions;
      }).catch(err => {
        this.message = this.$globalError(err);
        this.cityError = true;
        this.loader = false;
        window.scroll(0,0);
      })
    },
    
    cityUpdate(){
      this.successfuly = false;
      this.cityError = false;
      this.isLoading = true;

      const formData = new FormData();
      formData.append('regionId',this.region_id);
      formData.append('name',this.cityName);
      formData.append('nameEn',this.nameEn);
      formData.append('latitude',this.latitude);
      formData.append('longitude',this.longitude);
      formData.append('isActive',this.status);
      if(this.coverimg != '')
        formData.append('cover',this.coverimg);
      if(this.coverEn)
        formData.append('coverEn', this.coverEn);
      if(this.regaId)
        formData.append('regaId', this.regaId);

      this.$http.put(`/api/admin/cities/update/${this.city_id}`, formData).then(res => {
        this.coverimg = res.data.city.cover;
        this.coverEn = res.data.city.coverEn;
        this.isLoading = false;
        this.message = "تم التعديل بنجاح";
        this.successfuly = true;
        window.scroll(0,0);
      }).catch(err => {
        this.message = this.$globalError(err);
        this.cityError = true;
        this.isLoading = false;
        window.scroll(0,0);
      })
    },
    onFileAdd(files){
      this.coverimg = files[0];
    },
    onFileAddEn(files){
      this.coverEn = files[0];
    },
  },
  created() {
    this.region_get_Data();
  }
}
</script>